import React from 'react';
import styles from '@/styles/components/LogoLoader.module.css';

const LogoLoader: React.FC = () => {
  const maskUrl = `url(${process.env.PUBLIC_URL || ''}/icons/logo_S.svg)`;

  return (
    <div className={styles.overlay} role="status" aria-label="Loading">
      <div className={styles.logoWrapper}>
        <div
          className={styles.logoCutout}
          style={{
            WebkitMaskImage: maskUrl,
            maskImage: maskUrl,
            WebkitMaskRepeat: 'no-repeat',
            maskRepeat: 'no-repeat',
            WebkitMaskPosition: 'center',
            maskPosition: 'center',
            WebkitMaskSize: 'contain',
            maskSize: 'contain',
          }}
        />
      </div>
    </div>
  );
};

export default LogoLoader;

